/* unplugin-vue-components disabled */import script from "./index.vue?vue&type=script&name=User&setup=true&lang=js"
export * from "./index.vue?vue&type=script&name=User&setup=true&lang=js"

const __exports__ = script;

export default __exports__